import styled from 'styled-components'

export const ActiveWrapper = styled.div`
  margin-left: 44px;
  margin-top: 12px;
  .title {
    border: 1px solid #ddd;
    text-align: center;
    background: #fff6c9;
    text-transform: uppercase;
    font-size: 12px;
  }
  .columns {
    display: flex;
    .checkbox {
      margin: 0;
    }
    & > div {
      flex: 1;
      text-align: center;
      padding: 5px;
    }
  }
`

export const HolidayWrapper = styled.div`
  display: flex;
  .checkbox {
    margin: 0;
  }
`

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const Button = styled.button.attrs({
  className: 'btn btn-primary',
})``
